export default __webpack_public_path__ + "static/media/cloud_night.b55c9b2c.svg";